export const parseFileContentToContacts = (content: string) => {
  const emails: string[] = [];
  const phones: string[] = [];

  // Email regex pattern - matches standard email format
  const emailRegex = /\b[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Z|a-z]{2,}\b/g;

  // Phone regex pattern - must start with + followed by digits (minimum 7 digits after +)
  const phoneRegex = /\+\d{7,}/g;

  // Extract emails
  const emailMatches = content.match(emailRegex);
  if (emailMatches) {
    // Remove duplicates
    const uniqueEmails = Array.from(new Set(emailMatches));
    emails.push(...uniqueEmails);
  }

  // Extract phone numbers
  const phoneMatches = content.match(phoneRegex);
  if (phoneMatches) {
    // Remove duplicates
    const uniquePhones = Array.from(new Set(phoneMatches));
    phones.push(...uniquePhones);
  }

  return { emails, phones };
};
